var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-layout',[_c('template',{slot:"breadcrumb"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }